// Dependencies
import styled from 'styled-components';

const LocationsMapStyles = styled.section`
  text-align: center;

  .heading {
    font-weight: var(--font-weight-light);
  }

  .separator {
    margin: 2rem 0;
  }

  .img {
    margin: 1rem 0 2rem;
    max-width: 31.25rem;
  }

  .locations {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    list-style: none;
    margin: 1.5rem 0 0;

    li {
      margin: 0 0 0.563rem;
      padding: 0 0.375rem;
      width: calc(50% - 1.25rem);

      a {
        width: 100%;
      }

      &.more {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        height: 3.438rem;
        padding: 0 1.5rem;
        text-align: center;

        p {
          width: 100%;
          margin: 0;
          font-size: 0.938rem;
        }
      }

      &:last-child {
        padding-right: 0;
      }
    }
  }

  @media (min-width: 768px) {
    .img {
      margin: 2rem 0 3.5rem;
    }

    .text,
    .separator {
      display: none;
    }

    .locations {
      margin: 1rem 0 0;

      li {
        width: calc(25% - 1.25rem);
        margin: 0 0 1.25rem;
        padding: 0 0.563rem;

        &.more {
          p {
            font-size: 1.25rem;
          }
        }

        &:last-child {
          padding-right: 0;
        }
      }
    }
  }

  @media (min-width: 1200px) {
    .locations {
      li {
        width: calc(20% - 1.25rem);

        &.more {
          p {
            margin-top: -0.3rem;
          }
        }
      }
    }
  }

  @media (min-width: 1550px) {
    .locations {
      li {
        width: calc(16.6666666667% - 1.25rem);
      }
    }
  }

  @media (max-width: 767px) {
    .locations li {
      &:nth-child(odd) {
        padding-left: 0;
      }

      &:nth-child(even) {
        padding-right: 0;
      }

      &:nth-child(4n + 3) {
        margin-left: 2.5rem;
      }

      &:nth-child(4n + 2) {
        margin-right: 2.5rem;
      }

      &:last-child:nth-child(odd) {
        margin: 0;
      }
    }
  }

  @media (min-width: 768px) {
    @media (max-width: 1199px) {
      .locations li {
        &:first-child {
          padding-left: 0;
        }

        &:nth-child(4n) {
          padding-right: 0;
        }

        &:nth-child(8n + 1) {
          padding-left: 0;
        }

        &:nth-child(8n + 5) {
          margin-left: 5rem;
        }

        &:nth-child(8n + 4) {
          margin-right: 5rem;
        }

        &:last-child {
          margin: 0;
          padding-right: 0;
        }
      }
    }
  }

  @media (min-width: 1200px) {
    @media (max-width: 1549px) {
      .locations li {
        &:nth-child(9n + 6) {
          margin-left: 7.813rem;
        }

        &:nth-child(9n + 9) {
          margin-right: 7.813rem;
        }
      }
    }
  }

  @media (min-width: 1550px) {
    .locations li {
      &:nth-child(11n + 7) {
        margin-left: 7.813rem;
      }

      &:nth-child(11n + 11) {
        margin-right: 7.813rem;
      }
    }
  }
`;

export default LocationsMapStyles;
